// extracted by mini-css-extract-plugin
export default {"innerDatatable":"app-portainer-components-datatables-components-InnerDatatable-module__inner-datatable"};